import React from "react";
import { useSearchParams } from "react-router-dom";

import GoogleIcon from "@mui/icons-material/Google";

import { CookieStore } from "stores";

const googleParameters = ["utm_campaign"];

interface IGoogleAds {}
const GoogleAds: React.FC<IGoogleAds> = (): JSX.Element => {
  const [active, setActive] = React.useState<boolean>(false);
  const [title, setTitle] = React.useState<string>("");

  const [searchParams] = useSearchParams();
  const { dispatch: dispatchCookies } = React.useContext(CookieStore);

  React.useEffect(() => {
    googleParameters.map((name: string) => {
      const titles = [];
      if (searchParams.has(name)) {
        const value = searchParams.get(name);
        dispatchCookies({
          type: "ADD",
          payload: { name, value },
        });
        setActive(true);
        titles.push(name + ": " + value);
      } else {
        dispatchCookies({
          type: "DELETE",
          payload: { name },
        });
        setTitle("");
      }
      setTitle(titles.join(" | "));
    });
  }, []);

  return (
    <GoogleIcon
      sx={{ position: "absolute", top: 3, right: 3, opacity: 0 }}
      color={active ? "success" : "error"}
      fontSize="small"
      titleAccess={active ? title : ""}
    />
  );
};
export default GoogleAds;
